import axios from 'axios';
import { imgUrl, url, fontsApiKey } from 'utils/url';

const authConfig = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
    'Content-Type': 'application/json',
  },
});

const authConfigMultipart = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
  },
});

const unwrapData = (response) => response?.data?.data || [];

export const createBuilderServices = () => ({
  async listBuilders({ siteId }) {
    return unwrapData(await axios.get(`${url}/builder/site/${siteId}`, authConfig()));
  },
  async getBuilder({ builderId }) {
    return unwrapData(await axios.get(`${url}/builder/${builderId}`, authConfig()));
  },
  async createBuilder({ payload }) {
    return unwrapData(await axios.post(`${url}/builder`, payload, authConfig()));
  },
  async updateBuilder({ builderId, payload }) {
    return unwrapData(await axios.put(`${url}/builder/${builderId}`, payload, authConfig()));
  },
  async deleteBuilder({ builderId }) {
    await axios.delete(`${url}/builder/${builderId}`, authConfig());
  },
  async listPlaylist({ siteId }) {
    try {
      return unwrapData(await axios.get(`${url}/category?siteId=${siteId}`, authConfig()));
    } catch (error) {
      if (error.status === 404) {
        console.warn('Playlist endpoint returned 404. Defaulting to empty array.');
        return [];
      }
      throw error;
    }
  },
  async listMedia({ siteId, categoryId = 'all' }) {
    return unwrapData(
      await axios.post(
        `${url}/media/filter`,
        { siteId, categoryId, type: 'published' },
        authConfig()
      )
    );
  },
  async listTemplates({ siteId }) {
    return unwrapData(
      await axios.get(`${url}/template/list?siteId=${siteId}`, authConfig())
    );
  },
  async getTemplate({ siteId, templateId }) {
    return unwrapData(await axios.get(`${url}/template/${siteId}/${templateId}`, authConfig()));
  },
  async listScreens({ siteId }) {
    return unwrapData(
      await axios.get(`${url}/screen?siteId=${siteId}`, authConfig())
    );
  },
  async assignBuilder({ screenId, builderId }) {
    return unwrapData(
      await axios.post(`${url}/screen/${screenId}/assign-builder`, { builderId }, authConfig())
    );
  },
  async listScreenGroups({ siteId }) {
    return unwrapData(
      await axios.get(`${url}/screenGroup?siteId=${siteId}`, authConfig())
    );
  },
  async listPlaylistsBatch({ siteId, categoryIds }) {
    return unwrapData(
      await axios.post(`${url}/media/batch`, { siteId, categoryIds }, authConfig())
    );
  },
  async uploadFont({ siteId, name, file, weight, style }) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('siteId', siteId);
    formData.append('name', name);
    if (weight) formData.append('weight', weight);
    if (style) formData.append('style', style);

    return unwrapData(await axios.post(`${url}/font/upload`, formData, authConfigMultipart()));
  },
  async listCustomFonts({ siteId }) {
    return unwrapData(await axios.get(`${url}/font/list?siteId=${siteId}`, authConfig()));
  },
  async quickUploadMedia({ siteId, name, file }) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('siteId', siteId);
    if (name) formData.append('name', name);

    return unwrapData(await axios.post(`${url}/media/quick-upload`, formData, authConfigMultipart()));
  },
  async quickDeleteMedia({ siteId, mediaId }) {
    return unwrapData(
      await axios.post(`${url}/media/quick-delete`, { id: mediaId, siteId }, authConfig())
    );
  },
});

export const resolveBuilderMediaUrl = (media) => {
  if (!media) return null;
  if (media.logo) return `${imgUrl}/media/${media.logo}`;
  return null;
};

export const resolveFontUrl = (font) => {
  if (!font?.fileKey) return null;
  return `${imgUrl}/${font.fileKey}`;
};

export const builderFontsApiKey = fontsApiKey;